import { render, staticRenderFns } from "./SelectSubjectSISS.vue?vue&type=template&id=2b4d0d90&"
import script from "./SelectSubjectSISS.vue?vue&type=script&lang=js&"
export * from "./SelectSubjectSISS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4d0d90')) {
      api.createRecord('2b4d0d90', component.options)
    } else {
      api.reload('2b4d0d90', component.options)
    }
    module.hot.accept("./SelectSubjectSISS.vue?vue&type=template&id=2b4d0d90&", function () {
      api.rerender('2b4d0d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/informationFlow/subjects/SelectSubjectSISS.vue"
export default component.exports